import React, { createContext, useEffect, useMemo, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { Button, MenuItem, TextField } from "@mui/material";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import ModalTasasScreen from "./ModalTasasScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import EditIcon from "@mui/icons-material/Edit";
import { useHistory } from "react-router-dom";
import DescriptionIcon from '@mui/icons-material/Description';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

export const Context = createContext();

const ListadoTasasScreen = () => {
  const history = useHistory();
  const [informacion, setInformacion] = useState({
    open: false,
    item: -999,
    data: [],
  });

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [modalAbierto, setModalAbierto] = useState(false); // Estado para controlar el modal abierto

  //   const año = new Date().getFullYear();
  const [ejercicio, setEjercicio] = useState("");

  //   const mes = new Date().getMonth() + 1;
  const [periodo, setPeriodo] = useState("");

  const contextValue = useMemo(
    () => ({
      state: informacion,
      setState: setInformacion,
    }),
    [informacion, setInformacion]
  );

  const openModal = (item) => {
    // console.log(informacion)
    setInformacion({
      ...informacion,
      open: true,
      item: item,
    });
    setModalAbierto(true); // Cambia el estado del modal a abierto cuando se abre
  };

  useEffect(() => {
    actualizarListado();
  }, [ejercicio, periodo, modalAbierto]); // Agrega modalAbierto como una dependencia del useEffect

  const actualizarListado = () => {
    if (
      ejercicio === undefined ||
      ejercicio === null ||
      ejercicio === "" ||
      periodo === undefined ||
      periodo === null ||
      periodo === ""
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FTasaInteres/Listado?anio=${ejercicio}&mes=${periodo}`)
      .then((result) => {
        setInformacion({
          ...informacion,
          data: result,
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        Swal.fire("INTERESES", JSON.stringify(error), "error");
      });
  };

  const onDescargar = (idtasa) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FtasaInteres/ObtenerDocumento?idtipo_tasa=${idtasa}`)
      .then((result) => {
        const linkSource = result.documento;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombre}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  return (
    <PlantillaScreen
      titulo={"TASA DE INTERESES JDF"}
      className={"listado-tasa-intereses-main-screen"}
      className_main={1}
    >
      <Context.Provider value={contextValue}>
        <LoaderScreen loader={loader} />
        <div>
          <div className="top-separador"></div>
          <div className="tasa-intereses-screen-buttons">
            <div className="tasa-intereses-screen-filtrado">
              <TextField
                className="input-ejercicio"
                fullWidth
                size="small"
                label="Ejercicio"
                select
                type="text"
                onChange={({ target }) => {
                  setEjercicio(target.value);
                }}
                //   value={ejercicio}
                sx={{ width: 150 }}
              >
                <MenuItem value={"2024"}>2024</MenuItem>
                <MenuItem value={"2025"}>2025</MenuItem>
              </TextField>
              <TextField
                className="input-ejercicio"
                fullWidth
                size="small"
                label="Periodo"
                select
                type="text"
                onChange={({ target }) => {
                  setPeriodo(target.value);
                }}
                //   value={ejercicio}
                sx={{ width: 150 }}
              >
                <MenuItem value={1}>ENERO</MenuItem>
                <MenuItem value={2}>FEBRERO</MenuItem>
                <MenuItem value={3}>MARZO</MenuItem>
                <MenuItem value={4}>ABRIL</MenuItem>
                <MenuItem value={5}>MAYO</MenuItem>
                <MenuItem value={6}>JUNIO</MenuItem>
                <MenuItem value={7}>JULIO</MenuItem>
                <MenuItem value={8}>AGOSTO</MenuItem>
                <MenuItem value={9}>SEPTIEMBRE</MenuItem>
                <MenuItem value={10}>OCTUBRE</MenuItem>
                <MenuItem value={11}>NOVIEMBRE</MenuItem>
                <MenuItem value={12}>DICIEMBRE</MenuItem>
              </TextField>
            </div>
            <Button
              onClick={() => openModal()}
              variant="contained"
              sx={{ height: 30 }}
            >
              Agregar
            </Button>
          </div>
          <ModalTasasScreen
            updatedata={actualizarListado}
            idtasa={informacion.item}
            onClose={() => setModalAbierto(false)} // Cambia el estado del modal a cerrado cuando se cierra
          />
          <div className="bot-separador"></div>
          <div className="tabla-tasa-intereses scroll-4">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th className="primera-columna-tabla-tasas-intereses">
                    Descripción
                  </th>
                  <th>
                    <div>Registros</div>
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {informacion.data.map((item) => (
                  <tr>
                    <td className="primera-columna-tabla-tasas-intereses">
                      <div>
                        <DescriptionIcon />
                        {item.descripcion}
                      </div>
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        history.push("/Credito/tasavalores", {
                          idtipo_tasa: item.idtipo_tasa,
                          descripcion: item.descripcion,
                        })
                      }
                    ></td>
                    <td onClick={() => openModal(item.idtipo_tasa)}>
                      <div
                        className="button-table-intereses update"
                      >
                        <EditIcon />
                        Editar
                      </div>
                    </td>
                    <td>
                      {item.idtipo_tasa > 0 ? (
                        <div
                          className="button-table-intereses download"
                          onClick={() => onDescargar(item.idtipo_tasa)}
                        >
                          <CloudDownloadIcon />
                          Descargar
                        </div>
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Context.Provider>
    </PlantillaScreen>
  );
};

export default ListadoTasasScreen;
